import { GET_PLANT_LIST, LOADING_PLANT_LIST } from '../actions'

const INITIAL_STATE = {
    page: 1,
    isLoading: false,
    isLast: false,
    plants: [],
}

function PlantListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOADING_PLANT_LIST:
            return {
                ...state,
                isLoading: true,
            }
        case GET_PLANT_LIST:
            return {
                plants: [...state.plants, ...action.payload.body.plants],
                isLast: action.payload.body.last,
                isLoading: false,
                page: state.page + 1,
            }
        default: return state
    }
}

export default PlantListReducer



// WEBPACK FOOTER //
// ./src/reducers/plantList.js